import MainApp from './MainApp';

function init() {
    window.app = new MainApp({
        $el: document.body
    })
}

if (document.readyState === "complete" || document.readyState !== "loading") {
    init();
} else {
    document.addEventListener("DOMContentLoaded", init);
}